import FlussiListPage from "./pages/FlussiListPage.vue";
import FlussiViewPage from "./pages/FlussiViewPage.vue";

export default {
    FlussiListPage,
    FlussiViewPage
}